import style from './AccordionBase.module.scss';

const AccordionItem = ({ children, title, isActive, onClick }) => {
  return (
    <div className={style.accordion_item}>
      <button
        type="button"
        className={`${style.accordion_btn} ${isActive ? style['accordion_btn-active'] : ''}`}
        onClick={onClick}
      >
        {title}
      </button>
      {isActive && <div className={style.accordion_body}>{children}</div>}
    </div>
  );
};

export default AccordionItem;
